import { jsx as l, jsxs as i } from "react/jsx-runtime";
function t(e) {
  return /* @__PURE__ */ l("svg", { height: "1em", viewBox: "0 0 24 24", width: "1em", ...e, children: /* @__PURE__ */ i("g", { fill: "none", fillRule: "evenodd", children: [
    /* @__PURE__ */ l("path", { d: "M20 20H4V4h16z" }),
    /* @__PURE__ */ l(
      "path",
      {
        d: "M11.306 16.776l-6.69-6.443a.822.822 0 01-.023-1.163l.022-.022a.89.89 0 011.231 0L12 15.074l6.154-5.926a.888.888 0 011.23 0 .822.822 0 01.023 1.163l-.022.022-6.691 6.443a1 1 0 01-1.388 0z",
        fill: "#00182E"
      }
    )
  ] }) });
}
export {
  t as default
};
